// app/src/modules/ui/StatusBar.tsx — the footer.
//
// There wasn't one. The header carries the brand, the tabs and the clock, and
// the page just stopped at the last row — so the things a till needs to state
// continuously had nowhere to live and were scattered: connection and printer
// on the Sell tab only, branch and till in the header on some layouts, and who
// is signed in nowhere at all outside the account menu.
//
// A till is a shared machine. The three questions it must answer without being
// asked are: am I online, which till is this, and WHO IS SIGNED IN — that last
// one because a receipt gets stamped with the cashier's name, and the cost of
// getting it wrong is a sale attributed to whoever forgot to sign out.
//
// Kept to one line and out of the way. This is reference, not navigation.

import { useEffect, useState } from "react";
import { useSession } from "../../lib/session";
import { getDevice } from "../../lib/device";
import { useOnline } from "../../lib/sync";
import { fmtDateTime } from "../../lib/datetime";

export default function StatusBar() {
  const { user } = useSession();
  const online = useOnline();
  const device = getDevice();
  const [now, setNow] = useState(() => Date.now());

  // Ticks on the minute, not the second: a seconds display on a shared screen
  // is movement in the corner of the eye all day for information nobody needs.
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(id);
  }, []);

  const till = String(device.register_id ?? "reg_1").replace(/^reg_/, "");

  return (
    <footer className="statusbar" role="contentinfo">
      <span className="statusbar-item">
        <span className={`statusbar-dot ${online ? "is-on" : "is-off"}`} aria-hidden />
        {online ? "Online" : "Offline — sales will queue"}
      </span>

      <span className="statusbar-sep" aria-hidden>·</span>
      <span className="statusbar-item">{device.branch_code ?? "BR1"} · Till {till}</span>

      {user && <>
        <span className="statusbar-sep" aria-hidden>·</span>
        {/* Who the next receipt will be stamped with. */}
        <span className="statusbar-item statusbar-who">{user.display_name}</span>
      </>}

      <span className="statusbar-item statusbar-time num">
        {fmtDateTime(now, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
      </span>
    </footer>
  );
}
